/*
 * Página "Devoción a San Judas Tadeo" (/san-judas-tadeo).
 *
 * Cómo completarla: igual que src/contenido/historia.js
 * (texto con HTML sencillo, imagen = nombre de una foto de img/gallery).
 * La sección con tipo: "oracion" se muestra destacada, como una estampa.
 * Cuando esté lista, pon publicada: true en src/contenido/config.js.
 */

export default {
  clave: "sanJudas",
  eyebrow: "Devoción",
  titulo: "San Judas Tadeo",
  entradilla: "",
  imagen: "",
  icono: "local_fire_department",

  datos: [
    { icono: "celebration", etiqueta: "Festividad", valor: "28 de octubre" },
    { icono: "event_repeat", etiqueta: "Culto mensual", valor: "" },
    { icono: "schedule", etiqueta: "Misa", valor: "" },
    { icono: "favorite", etiqueta: "Patrón de", valor: "Las causas difíciles" },
  ],

  secciones: [
    { id: "quien-fue", icono: "person", titulo: "¿Quién fue San Judas Tadeo?", texto: "", imagen: "" },
    { id: "en-la-parroquia", icono: "church", titulo: "La devoción en Santo Domingo", texto: "", imagen: "" },
    { id: "dia-28", icono: "event_repeat", titulo: "Cada día 28", texto: "", imagen: "" },
    { id: "fiesta", icono: "celebration", titulo: "Fiesta y novena", texto: "", imagen: "" },
    { id: "oracion", icono: "front_hand", titulo: "Oración a San Judas Tadeo", texto: "", imagen: "", tipo: "oracion" },
  ],

  obras: [],
  albumId: 0,
};
